import { Component, EventEmitter, Input, Output, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';

import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';

import { MessageService } from 'primeng/components/common/messageservice';
import { IdiomaService } from '../providers/idioma/idioma.service';
import { PerfilIdiomaFormulario, PerfilFormulario } from '../domain/PerfilFormulario';
import { Idioma } from '../domain/Idioma';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { PermisosService, Permisos } from '../providers/authentication/permisos.service';
import { Constantes } from '../domain/constantes';

@Component({
	selector: 'app-formulario-perfil',
	templateUrl: './FormularioPerfilMovilidad.component.html',
	providers: [MessageService]
})

export class FormularioPerfilMovilidadComponent implements OnDestroy, OnChanges{

	@Input() perfilSeleccionado: any;
	@Input() edicion: boolean;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	spinner: HTMLElement;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	public permisos: Permisos = new Permisos();

	public confirmacionVisible = false;
	public operacion = '';
	public cancelarGuardado = true;
	constructor(
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		private idiomaService: IdiomaService,
		private permisosService: PermisosService) {

		const that = this;

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
			return true;
		})
		.then(function () {
			return that.comprobarPermisos();
		});
	}


	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.confirmacionVisible = false;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
	}

	ngOnDestroy(): void {
		if (this.cancelarGuardado) {
			this.entityManager.RejectChanges();
		}
	}
	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}
	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	inputChanged(value) {
		//  Cojemos la traduccion del espacio al idioma seleccionado
		const rutaSugeridaIdioma = this.perfilSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		rutaSugeridaIdioma.Nombre = this.perfilSeleccionado.Nomobre;
		rutaSugeridaIdioma.Descripcion = this.perfilSeleccionado.Descripcion;
		this.perfilSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, rutaSugeridaIdioma);
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		return true;
	}

	public guardar(): any {

		this.spinner.style.display = 'inherit';

		if (this.edicion) {
			return this.guardarEdicion();
		}
		else{
			return this.guardarNuevo();
		}
	}

	public guardarNuevo(){
		const that = this;
		this.cancelarGuardado = false;
		return that.entityManager.newPERFIL_MOVILIDAD_CIUDADANO()
		.then(function (oPerfil) {
			const idEspacio = that.authService.getIdEspacio();
			oPerfil.IdEspacio = idEspacio;

			oPerfil.IDIOMAS.forEach(PERFIL_MOVILIDAD_IDIOMA => {
				const aux = that.perfilSeleccionado.Idiomas.get(PERFIL_MOVILIDAD_IDIOMA.IDIOMA.Codigo);
				if(aux){
					PERFIL_MOVILIDAD_IDIOMA.Nombre = aux.Nombre;
				}
				else{
					const espacioIdioma = that.perfilSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
					if(espacioIdioma){
						PERFIL_MOVILIDAD_IDIOMA.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
					}
				}

			});

			const perfilIdioma = that.perfilSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.perfilSeleccionado.Nomobre = perfilIdioma.Nombre ? perfilIdioma.Nombre : '';

			oPerfil.Nomobre = that.perfilSeleccionado.Nomobre;
			oPerfil.PesoMAximo = Constantes.PESO_DEFAULT; // that.perfilSeleccionado.PesoMAximo;

			that.perfilSeleccionado.Id = oPerfil.Id;

			that.perfilSeleccionado.ENTIDAD = oPerfil;

			return that.entityManager.saveChanges();

		})
		.then(function(data: any) {
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function(){
			console.log('PERFIL Guardado CORRECTAMENTE = ' + that.perfilSeleccionado.Nombre);
			that.onElementoGuardado.emit(that.perfilSeleccionado);
			// return true;
		})
		.catch(function (e) {
			that.onElementoError.emit(that.perfilSeleccionado);
			that.spinner.style.display = 'none';
		});

	}

	guardarEdicion(){
		const that = this;
		return this.guardarMultiIdioma()
		.then(function () {
			const perfilIdioma = that.perfilSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.perfilSeleccionado.Nomobre = perfilIdioma.Nombre ? perfilIdioma.Nombre : '';

			that.perfilSeleccionado.ENTIDAD.Nomobre = that.perfilSeleccionado.Nomobre;
			that.perfilSeleccionado.ENTIDAD.PesoMAximo =  Constantes.PESO_DEFAULT; // that.perfilSeleccionado.PesoMAximo;
			return that.entityManager.saveChanges();
		})
		.then(function(data: any) {
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function(){
			console.log('PERFIL Guardado CORRECTAMENTE = ' + that.perfilSeleccionado.ENTIDAD.Nomobre);
			that.onElementoGuardado.emit(that.perfilSeleccionado);
		})
		.catch(function (e) {
			that.onElementoError.emit(that.perfilSeleccionado);
			that.spinner.style.display = 'none';
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.perfilSeleccionado.ENTIDAD.IDIOMAS);

		return this.entityManager.newPERFIL_MOVILIDAD_CIUDADANO_IDIOMA(this.perfilSeleccionado.ENTIDAD)
		.then(function(PERFIL_MOVILIDAD_CIUDADANOs){

			PERFIL_MOVILIDAD_CIUDADANOs.forEach(PERFIL_MOVILIDAD_CIUDADANO => {
				const aux = that.perfilSeleccionado.Idiomas.get(PERFIL_MOVILIDAD_CIUDADANO.IDIOMA.Codigo);
				if (aux) {
					PERFIL_MOVILIDAD_CIUDADANO.Nombre = aux.Nombre;
				}
			});

		})
		.catch(function (e) {
			that.onElementoError.emit(that.perfilSeleccionado);
			that.spinner.style.display = 'none';
		});
	}

	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let perfilIdioma = this.perfilSeleccionado.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!perfilIdioma) {

			perfilIdioma = new PerfilIdiomaFormulario();

			this.perfilSeleccionado.Idiomas.set(idioma.value, perfilIdioma);

		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.perfilSeleccionado.Nomobre = perfilIdioma.Nombre;
	}

	cancelar(){
		this.operacion = '';
		this.confirmacionVisible = false;
	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioPerfilMovilidad.component.ts